import { DEFAULT_TIMEZONE, money as coreMoney, type MenuQuadrant, type SpecStatus } from "@baros/core";

let currentZone = DEFAULT_TIMEZONE;

/**
 * The zone the screens show times in: the venue being looked at, not the
 * device's. Somebody signed in from overseas sees the bar's own clock — the
 * same "10:40 pm" the bartender sees — rather than their own. Set by the
 * app whenever the venue's settings load.
 */
export function venueZone(): string {
  return currentZone;
}

export function setVenueZone(zone: string): void {
  currentZone = zone;
}

export const money = coreMoney;

export function pct(n: number, digits = 1): string {
  return Number.isFinite(n) ? `${n.toFixed(digits)}%` : "—";
}

export const STATUS_LABEL: Readonly<Record<SpecStatus, string>> = {
  available: "Available",
  "needs-testing": "Needs testing",
  "not-active": "Not active",
  retired: "No longer available",
};

export const STATUS_ORDER: readonly SpecStatus[] = [
  "available",
  "needs-testing",
  "not-active",
  "retired",
];

export function statusColour(status: SpecStatus): string {
  switch (status) {
    case "available":
      return "var(--pos)";
    case "needs-testing":
      return "var(--warn)";
    case "retired":
      return "var(--neg)";
    default:
      return "var(--t2)";
  }
}

/** Menu engineering's colour for each quadrant — the plot, and the Recipes tags. */
export function quadrantColour(quadrant: MenuQuadrant): string {
  switch (quadrant) {
    case "star":
      return "var(--pos)";
    case "plough-horse":
      return "var(--warn)";
    case "puzzle":
      return "var(--accent)";
    case "dog":
      return "var(--neg)";
  }
}

/** `2026-09-05T04:00:00Z` → `05 Sep 26`. */
export function shortDate(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString("en-AU", { day: "2-digit", month: "short", year: "2-digit", timeZone: venueZone() });
}

/** Dark by default, light between 04:00 and 16:00 — the prototype's rule. */
export function themeForNow(now = new Date()): "dark" | "light" {
  const h = now.getHours();
  return h >= 4 && h < 16 ? "light" : "dark";
}
